import { http, refreshAccessToken } from '@/shared/api/http';
import { useAuth, type AuthUser } from './auth-store';

interface LoginResponse {
  access_token: string;
  token_type: string;
  expires_in: number;
}

export interface MeResponse {
  id: string;
  email: string;
  role: 'user' | 'platform_admin';
  full_name?: string;
  avatar_url?: string;
}

export async function login(email: string, password: string): Promise<void> {
  const data = await http<LoginResponse>('/auth/login', {
    method: 'POST',
    body: JSON.stringify({ email, password }),
  });
  useAuth.getState().set({ accessToken: data.access_token });
  const user = await http<MeResponse>('/me');
  useAuth.getState().set({ status: 'authed', user: user as AuthUser });
}

export async function refresh(): Promise<void> {
  return refreshAccessToken();
}

export async function logout(): Promise<void> {
  try {
    await http('/auth/logout', { method: 'POST' });
  } finally {
    useAuth.getState().set({ status: 'anon', accessToken: null, user: null });
  }
}

export async function passwordResetRequest(email: string): Promise<void> {
  await http('/auth/password-reset/request', {
    method: 'POST',
    body: JSON.stringify({ email }),
  });
}

export async function passwordResetConfirm(token: string, new_password: string): Promise<void> {
  await http('/auth/password-reset/confirm', {
    method: 'POST',
    body: JSON.stringify({ token, new_password }),
  });
}
